<template>
    <div class="">
        <div class="flex justify-between items-center py-2 flex-wrap">
            <div class="flex flex-wrap gap-4 py-2">
                <SearchBar @server-selected="serverSelectedHandeler">
                </SearchBar>

                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Usage Status
                    <v-select v-model="selectedSaleStatus" :items="saleStatusList" density="compact" variant="outlined"
                        rounded="0" placeholder="Select Sale Status" style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
                <div v-if="selectedServerName !== ''" class="w-56 pr-5 text-xs">
                    Proxy Connect Status
                    <v-select v-model="selectedConnStatus" :items="connectStatusList" density="compact" rounded="0"
                        variant="outlined" placeholder="Select Conn Status"
                        style="padding-top: 0px;padding-bottom: 0px;">
                    </v-select>
                </div>
            </div>
            <div v-if="selectedServerName !== ''">
                <v-btn icon="mdi-delete" size="small" style="outline: none;" @click="deleteProxies"
                    class="mr-5 bg-dark text-light"></v-btn>
                <v-btn v-if="selectedServerName !== 'All' && selectedServerType === 'PROPROXYUI'" icon="mdi-plus" size="small" style="outline: none;"
                    class="bg-dark text-light" @click="ppuiRef?.openAdd()"></v-btn>
                <v-btn v-if="selectedServerName !== 'All' && selectedServerType !== 'PROPROXYUI'" icon="mdi-plus" size="small" style="outline: none;"
                    data-bs-toggle="modal" 
                    :data-bs-target="selectedServerType === 'X_PROXY' ? '#xproxyAddModal' :
                                     selectedServerType === 'PROXYSMART' ? '#proxysmartAddModal' :
                                     selectedServerType === 'IPROXY' ? '#iproxyAddModal' : ''"
                    :disabled="selectedServerType === 'IPROXY' && iproxyAccessExists"
                    class="bg-dark text-light" @click="addProxy"></v-btn>
            </div>
        </div>
        <div v-if="loading === true" class=" flex items-center justify-center absolute custom-style " >
            <img src="../../../assets/loading.gif" class="w-[50px]"/>
        </div>
        <v-btn-toggle v-model="viewType" color="deep-purple-accent-3 " rounded="0" group class="border-b-none border"
            mandatory>
            <v-btn value="table" class="bg-white text-black">
                Table
            </v-btn>
            <v-btn value="graph" class="bg-white text-black ">
                Graph
            </v-btn>
        </v-btn-toggle>
        <!-- ProProxyUI servers: one port = HTTP + SOCKS5, their own table -->
        <ProProxyUiTable v-if="viewType === 'table' && selectedServerType === 'PROPROXYUI'" ref="ppuiRef"
            :selectedServerName="selectedServerName" :selectedSaleStatus="selectedSaleStatus" :selectedConnStatus="selectedConnStatus" />
        <TableView ref="tableViewRef" :selectedConnStatus="selectedConnStatus" :selectedServerName="selectedServerName"
            :selectedSaleStatus="selectedSaleStatus" :selectedServerType="selectedServerType"
            v-else-if="viewType === 'table'" class="border bg-white text-black" />
        <GraphView modem v-if="viewType === 'graph'" class="border bg-white text-black" />
    </div>
    <div>
        <XProxyAddNewOneDialog v-if="selectedServerType === 'X_PROXY'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
        <ProxySmartAddNewOneDialog v-if="selectedServerType === 'PROXYSMART'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
        <IProxyAddNewOneDialog v-if="selectedServerType === 'IPROXY'" @close="addNewOneDialogFlag = false" :serverName="selectedServerName" />
    </div>
</template>
<script setup>
import { ref } from 'vue';
import { useAdminProxyStore, useAlertStore } from "@/stores"
import { storeToRefs } from 'pinia';
import SearchBar from './SearchBar.vue';
import GraphView from "./GraphView.vue";
import TableView from "./TableView.vue";
import XProxyAddNewOneDialog from "./Modals/AddNewOneDialog-XProxy.vue"
import ProxySmartAddNewOneDialog from "./Modals/AddNewOneDialog-ProxySmart.vue"
import IProxyAddNewOneDialog from "./Modals/AddNewOneDialog-IPROXY.vue"
import ProProxyUiTable from "./ProProxyUiTable.vue"

import { watchEffect } from 'vue';
import { watch } from 'vue';
const viewType = ref("table")

const adminProxyStore = useAdminProxyStore()
const { xProxies, smartProxies, loading, serverNames } = storeToRefs(adminProxyStore)
const addNewOneDialogFlag = ref(false)
const selectedServerName = ref("All")
const selectedServerType = ref("X_PROXY")
const iproxyAccessExists = ref(false)


const serverSelectedHandeler = (server) => {
    if (!server) return;
    selectedServerName.value = server.name;
    // Prefer the type coming from the SearchBar (so filters like PROXYSMART/IPROXY work),
    // and fall back to the server record's modem_type only if type is missing.
    const record = serverNames.value.find(s => s.name === server.name);
    const resolvedType = server.type || record?.modem_type || 'ALL';
    selectedServerType.value = resolvedType;
    adminProxyStore.loadProxies(server.name);
    if (resolvedType === 'IPROXY') {
        adminProxyStore.hasIProxyAccess(server.name).then(({ exists }) => {
            iproxyAccessExists.value = !!exists;
        });
    } else {
        iproxyAccessExists.value = false;
    }
}
const addProxy = () => {
    addNewOneDialogFlag.value = true
}
const saleStatusList = ref(['All', 'AVAILABLE', 'USED'])
const connectStatusList = ref(['All', 'CONNECTED', 'DISCONNECTED', 'PAUSED'])
const selectedSaleStatus = ref('All')
const selectedConnStatus = ref('All')

const selectedItems = ref([])

const tableViewRef = ref(null)
const ppuiRef = ref(null)   // ProProxyUI ports table
const deleteProxies = () => {
    if (selectedServerType.value === 'PROPROXYUI') ppuiRef.value?.deleteProxies()
    else tableViewRef.value.deleteProxies()
}
</script>

<style scoped>
.custom-style {
    width: -webkit-fill-available; /* Safari/WebKit */
    height: -webkit-fill-available; /* Safari/WebKit */
    width: -moz-available; /* Firefox */
    height: -moz-available; /* Firefox */
    width: fill-available; /* Standard syntax, for future compatibility */
    height: fill-available; /* Standard syntax, for future compatibility */
}
</style>